const DATA_STORES_TYPES = {
  MERGE_ENTITIES_INTO_STORES: '[dataStores] mergeEntitiesIntoStores'
}

export default DATA_STORES_TYPES
